import {Vue} from 'vue-property-decorator';
import {api} from '@/services/http';
import {AxiosResponse} from 'axios';

export const TextQualityValidator: object = {
    getMessage(field: any, args: number[]|null): string {
        return Vue.i18n.translate('validator.text-quality.error', 'Invalid') || 'Invalid character(s) entered.';
    },

    validate: async (value: string|null): Promise<boolean> => {
        try {
            const response: AxiosResponse = await api.axios.post('/api/validate/quality', {
                text: value,
            });

            if (!response.data) {
                return false;
            }

            return true;
        } catch (e) {
            return false;
        }
    },
};
